export default {
  PhotoReview: {
    queued: { Text: 'En attente de révision' },
    reviewed: { Text: 'Révisé' },
  },
  PhotoRating: {
    pending: {
      Text: 'En attente de révision',
      Description:
        'Disponible pour la plupart des utilisateurs (ceux qui ont désactivé la navigation sécurisée)',
    },
    public: {
      Text: 'Public',
      Description: 'Disponible pour tout le monde',
    },
    'public-sensitive': {
      Text: 'Public',
      Description:
        'Disponible pour la plupart des utilisateurs (ceux qui ont désactivé la navigation sécurisée)',
    },
    banned: {
      Text: 'Contenu interdit',
      Description: 'Marqué pour suppression',
    },
    private: {
      Text: 'Privé',
      Description: 'Disponible uniquement pour les utilisateurs que tu as autorisés',
    },
    message: {
      Text: 'Élément de message',
      Description: 'Pour le destinataire uniquement',
    },
    other: {
      Text: 'Inconnu',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'Occupation',
      TextField2: 'Éducation',
      TextField3: 'Intérêts',
    },
    ferzu: {
      TextField1: 'Mon Fursona',
      TextField2: 'Occupation / Éducation',
      TextField3: 'Intérêts',
    },
    pupspace: {
      TextField1: 'Mes loisirs',
      TextField2: 'Mes kinks et mon équipement',
      TextField3: 'Mes limites et ma santé',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandoms et jeu de rôle' },
    plusSize: { Name: 'Grande taille' },
    menInterestedInMen: { Name: 'Hommes intéressés par les hommes' },
  },
  CommunityInfo: {
    headings: {
      about: 'À propos de {{communityName}}',
      whatYouCanDo: 'Ce que tu peux faire sur {{communityName}}',
      rules: 'Nos règles de communauté',
      welcome: 'Bienvenue sur {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainers & Encouragers (gay)',
        description:
          'Une communauté de gainers et encouragers pour hommes gays et bisexuels qui célèbre la positivité corporelle, la croissance, l\'inclusion et l\'acceptation.',
        sections: {
          about:
            'Grommr est fier de servir la communauté des gainers/encouragers gays et bisexuels depuis 2011. La communauté Grommr réunit une grande diversité d\'hommes du monde entier qui partagent une chose en commun : la conviction que plus, c\'est mieux.\n\nGrommr offre un forum inclusif pour que notre communauté se connecte, tisse des liens et s\'épanouisse. Nous coordonnons également des rencontres locales régulières (appelées GrommOffs) et organisons des conférences semestrielles plus importantes, telles que The Grom et EuroGrom.\n\nNous ne sommes pas le premier réseau à servir la communauté gainer/encourager, active depuis les années 1980. Pour en savoir plus sur l\'histoire de cette formidable communauté body-positive, consultez <a href="https://www.grommr.com/Home/Community">The Gainer History Project</a>.',
          whatYouCanDo:
            ' • Parcourir le fil d\'actualité, publier, commenter et participer aux discussions.\n • Explorer les profils à proximité ou rechercher des membres ayant des centres d\'intérêt similaires.\n • Démarrer des discussions avec de nouveaux contacts ou d\'anciens amis.\n • Partager tes photos ou consulter les photos récentes des autres membres.\n • Découvrir les événements de la communauté gainer près de chez toi.',
          rules:
            'Nous nous efforçons de faire de Grommr un foyer accueillant pour tous nos membres. Toute activité illégale, le trolling, le harcèlement, le racisme, la misogynie, l\'homophobie, la transphobie, le validisme, la grossophobie, ainsi que l\'exhibition publique de nudité ou d\'actes sexuels sont strictement interdits sur Grommr.',
          welcome:
            'Si notre équipe d\'administration peut t\'aider, n\'hésite pas à ouvrir un ticket d\'assistance ou à nous envoyer un e‑mail.\n\nBienvenue !\n\nL\'équipe Grommr',
        },
      },
      feabie: {
        caption: 'Feedism & BBW',
        description:
          'Une communauté feedism pour tous, qui célèbre la positivité corporelle, la croissance, l\'inclusion et l\'acceptation.',
        sections: {
          about:
            'Feabie offre un environnement inclusif où les membres de la communauté feedism — de toutes orientations — peuvent se connecter, pour discuter, avoir un rendez‑vous ou participer à un événement communautaire. Nous accueillons feedists, admirateurs de ronds, BBW/BHM et toute personne qui se sent chez elle sur Feabie.\n\nEn plus de notre communauté en ligne, Feabie coordonne également FeabieMeets — une série de rencontres locales qui rassemblent une grande diversité de membres Feabie pour se rencontrer hors ligne.\n\nFeabie est le plus grand réseau social au service de la communauté feedism et l\'un des plus grands réseaux body‑positive au monde.',
          whatYouCanDo:
            ' • Parcourir le fil d\'actualité, publier, commenter et participer aux discussions.\n • Explorer les profils à proximité ou rechercher des membres ayant des centres d\'intérêt similaires.\n • Démarrer une discussion et fixer un rendez‑vous, ou simplement retrouver des amis.\n • Partager tes photos ou consulter les photos récentes des autres membres.\n • Découvrir les événements feedism près de chez toi.',
          rules:
            'Nos administrateurs travaillent dur pour que Feabie soit aussi inclusif et accueillant que possible. Les activités illégales, le trolling, le harcèlement, le racisme, la misogynie, l\'homophobie, la transphobie, le validisme, la grossophobie et l\'exhibition publique de nudité ou d\'actes sexuels sont strictement interdits sur Feabie.',
          welcome:
            'Nos administrateurs sont là pour t\'aider ! Si tu as une question ou une inquiétude, n\'hésite pas à ouvrir un ticket d\'assistance ou à nous envoyer un e‑mail.\n\nBienvenue !\n\nL\'équipe Feabie',
        },
      },
      chasabl: {
        caption: 'Bears, Chubs & Chasers (gay)',
        description:
          'Une communauté chub‑bear pour hommes gays et bisexuels qui célèbre la positivité corporelle, l\'inclusion et l\'acceptation.',
        sections: {
          about:
            'Chasable est fier d\'être, depuis 2013, le plus grand réseau social pour la communauté chub‑bear. Depuis, Chasable s\'est forgé une réputation d\'environnement accueillant pour des hommes gays et bisexuels de toutes tailles, formes et couleurs. Nous accueillons chubs, bears, chasers et tous ceux entre les deux.\n\nBien que plusieurs applications de rencontres desservent la communauté chub‑bear, aucune n\'offre les fonctionnalités sociales de Chasable. Le fil Chasable est un pôle vital de discussion, de partage de photos et de soutien pour la communauté.\n\nChasable soutient régulièrement de grands événements chub‑bear, comme Tidal Wave à Orlando et les soirées BGMO à New York, et aide à promouvoir des événements chub‑bear dans le monde entier.',
          whatYouCanDo:
            ' • Explorer les profils à proximité ou rechercher des chubs, bears et chasers ayant des intérêts similaires.\n • Partager tes photos ou consulter les photos récentes des autres membres.\n • Parcourir le fil d\'actualité, publier, commenter et participer aux discussions.\n • Envoyer un clin d\'œil, démarrer une discussion avec un nouveau membre ou retrouver des amis.\n • Découvrir les événements chub‑bear près de chez toi.',
          rules:
            'Les administrateurs de Chasable contribuent à faire de notre communauté un espace sûr pour tous. Les activités illégales, le trolling, le harcèlement, le racisme, la misogynie, l\'homophobie, la transphobie, le validisme, la grossophobie et l\'exhibition publique de nudité ou d\'actes sexuels sont strictement interdits sur Chasable.',
          welcome:
            'Des questions ? Tu vois quelque chose qui ne devrait pas être sur Chasable ? Notre équipe d\'administration est là pour t\'aider ! Ouvre un ticket d\'assistance à tout moment ou écris‑nous.\n\nBienvenue !\n\nL\'équipe Chasable',
        },
      },
      ferzu: {
        caption: 'Furries & Anthros',
        description:
          'Une communauté furry pour tous qui célèbre le fandom furry, l\'art furry et l\'inclusion.',
        sections: {
          about:
            'Ferzu est le plus grand réseau social dédié au fandom furry. Que ton fursona marche, vole ou nage, que tu sois hétéro ou LGBTQ, rond ou mince, rayé ou tacheté, tu trouveras un foyer inclusif sur Ferzu.\n\nNous sommes fiers d\'offrir un espace sûr où tous les furries peuvent se connecter et s\'épanouir. Bien souvent, des discussions ont lieu sur Ferzu qui n\'auraient jamais lieu sur des réseaux sociaux traditionnels plus tolérants envers les trolls.',
          whatYouCanDo:
            ' • Parcourir le fil d\'actualité, publier, commenter et participer aux discussions.\n • Découvrir les dernières œuvres d\'art furry et partager les vôtres.\n • Explorer les profils à proximité ou rechercher des furries avec des intérêts similaires.\n • Démarrer des discussions avec de nouveaux contacts ou d\'anciens amis.\n • Se renseigner sur les conventions furry, voir qui y va et rejoindre la fête.',
          rules:
            'Ferzu est un espace sûr pour tous les furries. Par conséquent, le trolling, le harcèlement, le racisme, la misogynie, l\'homophobie, la transphobie, le validisme et l\'exhibition publique de nudité ou d\'actes sexuels sont strictement interdits.\n\nNous tenons également beaucoup aux artistes qui sont l\'épine dorsale de notre communauté. Nos administrateurs appliquent donc des règles strictes pour protéger l\'art furry.',
          welcome:
            'Notre équipe d\'administration est toujours disponible pour répondre à tes questions ou t\'aider sur Ferzu. Si tu as besoin de quoi que ce soit, n\'hésite pas à ouvrir un ticket d\'assistance ou à nous envoyer un e‑mail.\n\nUn grand accueil furry !\n\nL\'équipe Ferzu',
        },
      },
      pupspace: {
        caption: 'Chiens humains & handlers',
        description:
          'Une nouvelle communauté de pup play pour les chiens humains, les handlers et toute personne aimant entrer dans le headspace de chiot.',
        sections: {
          about:
            'Pupspace est le premier réseau social et la première application dédiés à la communauté du puppy play et à nos amis. Les membres de tous genres, identités et horizons sont les bienvenus.\n\nNous nous efforçons de construire une communauté inclusive et bienveillante pour tous nos membres, peu importe ton identité, ton lieu de vie ou ta situation. Pupspace est un lieu sûr où chacun est libre d\'explorer, d\'être soi‑même, d\'entrer dans le headspace de chiot et de libérer son chiot intérieur.',
          whatYouCanDo:
            '• Parcourir le fil d\'actualité, publier, commenter et participer aux discussions avec d\'autres chiens et handlers.\n• Explorer les profils à proximité ou rechercher des chiens aux intérêts similaires.\n• Démarrer une discussion, fixer une session de jeu ou simplement retrouver des amis.\n• Partager tes photos ou consulter les photos récentes d\'autres chiens.\n• Découvrir les événements et moshes de chiots près de chez toi.',
          rules:
            'Les administrateurs de Pupspace travaillent dur pour que notre communauté soit aussi inclusive et accueillante que possible. Les activités illégales, le trolling, le harcèlement, le racisme, la misogynie, l\'homophobie, la transphobie, le validisme et l\'exhibition publique de nudité ou d\'actes sexuels sont strictement interdits sur Pupspace.',
          welcome:
            'Nos administrateurs sont là pour t\'aider ! Si tu as une question ou une inquiétude, n\'hésite pas à ouvrir un ticket d\'assistance ou à nous envoyer un e‑mail.\n\nBienvenue dans ton nouveau foyer ! *wags*\n\nL\'équipe Pupspace',
        },
      },
    },
  },
  communities: {
    myCommunities: 'Mes communautés',
  },
  PostType: {
    ChangedLocation: 'A changé sa localisation en : {{text}}',
    ChangedNickname: "A changé son nom d'utilisateur : {{text}}",
    ChangedRelStatus: 'A changé son statut de relation',
    ChangedWeight: 'A changé son poids à {{newWeight}}, un gain de {{newWeightDiff}}',
    NewMember: 'A rejoint {{communityName}}',
    NewPhoto: 'A posté une nouvelle photo',
    NewEvent: 'A posté un nouvel événement : ',
    NotifyNewComment: {
      post: 'a commenté une publication',
      photo: 'a commenté une photo',
    },
    NotifyNewFollow: 'a commencé à te suivre',
    NotifyNewWallToWall: 'a posté sur ton mur',
    NotifyPhotoLike: 'a aimé ta photo',
    NotifyUnlocked: "t'a accordé l'accès à ses photos privées",
    NotifyUnlockRequest: "demande l'accès à tes photos privées",
  },
  TransactionType: {
    Admin: 'Pass {{premium}} admin',
    Adjustment: 'Ajustement',
    BOGO: 'Promotion {{premium}} (achetez-en un, obtenez-en un gratuit)',
    Courtesy: 'Pass {{premium}} de courtoisie',
    DonationWithPaypal: 'Donation, merci ! (payé avec PayPal)',
    FoundingMember: 'Pass {{premium}} de membre fondateur',
    GiftCertificatePaidFor: 'Achat de certificat cadeau {{premium}}',
    GiftCertificateRedeemed: 'Certificat cadeau {{premium}} échangé',
    PaidByMail: 'Achat de pass {{premium}} (payé par espèces/chèque/mandat)',
    PaidWithApple: 'Abonnement {{premium}} (payé avec Apple App Store)',
    PaidWithCCBill: 'Abonnement {{premium}} (payé avec CCBill)',
    PaidWithGoogle: 'Abonnement {{premium}} (payé avec Google Play)',
    PaidWithPaypal: 'Achat de pass {{premium}} (payé avec PayPal)',
    PaidWithStripe: 'Abonnement {{premium}} (payé avec Stripe)',
    Referrals: 'Temps {{premium}} gagné par parrainages',
    Refund: 'Crédit/Remboursement',
    Trial: 'Essai gratuit {{premium}}',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Aisselles',
      ArmsLegs: 'Bras/jambes',
      Asses: 'Fesses',
      Athletic: 'Athlétique',
      Average: 'Moyen',
      Balbo: 'Balbo',
      BallBelly: 'Ventre rond',
      Beard: 'Barbe',
      Beards: 'Barbes',
      Bellies: 'Ventres',
      BellyButtons: 'Nombrils',
      BodyMods: 'Modification corporelle',
      Breasts: 'Seins (féminins)',
      BreastsFemale: 'Seins (féminins)',
      BreastsMale: 'Seins (masculins)',
      ChestPecs: 'Poitrine/pectoraux',
      ChinStrap: 'Colier de barbe',
      Chubby: 'Potelé partout',
      Chubby2: 'Potelé',
      ChubbyBelly: 'Potelé avec un ventre',
      ChunkyMuscle: 'Gros muscles',
      Curvy: 'Courbure',
      Feet: 'Pieds',
      First30: 'Premiers 30 livres',
      FullBeard: 'Barbe complète',
      Goatee: 'Bouc',
      Hairy: 'Poilu',
      Hands: 'Mains',
      Husky: 'Costaud',
      LightBeard: 'Barbe légère',
      LoveHandles: "Poignées d'amour",
      ManTits: 'Seins masculins',
      Moustache: 'Moustache',
      MuscleGut: 'Muscle et ventre',
      Muscular: 'Musclé',
      MuttonChops: 'Favoris',
      Nipples: 'Tétons',
      None: 'Aucune',
      PearChubby: 'Potelé en forme de poire',
      PencilThin: 'Ligne fine',
      Piercings: 'Piercings',
      SlightlyChubby: 'Légèrement potelé',
      Slim: 'Mince',
      Smooth: 'Lisse',
      SomeHair: 'Quelques poils',
      SuperChub: 'Super potelé',
      SuperChubby: 'Super potelé',
      Tattoos2: 'Tatouages',
      ThickCurvy: 'Épais/Courbure',
      Thin: 'Mince',
      Toned: 'Muscle tonique',
      Trimmed: 'Taillé',
      VanDyke: 'Van Dyke',
      VeryChubby: 'Très potelé',
      VeryHairy: 'Très poilu',
    },
    Other: {
      AfterCare: 'Aftercare',
      Agender: 'Agenre',
      AgePlay: "Jeu d'âge",
      AnalPlayBottom: 'Anal (passif)',
      AnalPlayTop: 'Anal (actif)',
      Androgynous: 'Androgyne',
      Asexuality: 'Asexualité',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Jeu de ballons',
      Bathing: 'Bain/Douche',
      BDSM: 'BDSM',
      Belching: 'Rots',
      BellyPlay: 'Jeu de ventre',
      BellyRubs: 'Caresses du ventre',
      Biting: 'Mordre',
      BitsGags: 'Mors/Bâillons',
      Bloating: 'Ballonnement',
      Blueberry: 'Myrtille',
      BodyOdors: 'Parfum/Odeur corporelle',
      Bodypaint: 'Peinture corporelle',
      BodyWorship: 'Adoration du corps',
      Bondage: 'Bondage/domination',
      Bondage2: 'Bondage',
      Boots: 'Bottes',
      BootsHeels: 'Bottes et talons hauts',
      BootsWorship: 'Adoration des bottes',
      BowlEating: 'Manger dans un bol',
      Brats: 'Gâtés',
      BreastGrowth: 'Croissance des seins',
      BreathPlay: 'Jeu de respiration',
      Burping: 'Rots',
      Businessmen: "Hommes d'affaires",
      ButtplugsDildos: 'Plugs anaux/Godes',
      CageSleep: 'Dormir en cage',
      CBT: 'CBT',
      Chastity: 'Chasteté',
      Cigars: 'Cigares/pipes/tabac',
      CollaredOwned: 'Avec collier/Possédé',
      Complicated: "C'est compliqué",
      Control: 'Contrôle',
      CrossDress: 'Travestissement',
      Cuckolding: 'Cocufiage',
      Cuddling: 'Câlins/frottage',
      CunnGiver: 'Cunnilingus (donneur)',
      CunnReceiver: 'Cunnilingus (receveur)',
      DaddySon: 'Jeu de rôle papa-fils',
      Dating: 'Rencontres',
      DatingBreak: 'En pause côté rencontres',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Parler cru',
      Discipline: 'Discipline/Punitions',
      DoctorPatient: 'Jeu de rôle médecin-patient',
      Dogshow: 'Exposition canine',
      Domination: 'Domination',
      DomSub: 'Domination/soumission',
      EdgePlay: 'Jeu extrême',
      EdgingOrgasm: "Contrôle d'orgasme/edging",
      Engaged: 'Fiancé',
      EStim: 'Électrostimulation',
      Exhibitionism: 'Exhibitionnisme/Sexe public',
      ExplodBellies: 'Ventres qui explosent',
      FaceSitting: "S'asseoir sur le visage",
      Farting: 'Pets',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (receveur)',
      FeedingFeeder: 'Feeding (donneur)',
      Female: 'Femme',
      Feminine: 'Féminine',
      Fighting: 'Lutte/Combat',
      Fingering: 'Doigtage',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (passif)',
      FistingTop: 'Fisting (actif)',
      Flogging: 'Flagellation/Fouets',
      FootWorship: 'Adoration des pieds',
      ForceFeeding: 'Gavage forcé',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Prendre du poids/encourager',
      GainingInstant: 'Gain instantané',
      GainingLT: 'Gain à long terme',
      Gassy: 'Gazeux',
      Genderfluid: 'Genre fluide',
      GenderNonconforming: 'Non-conforme au genre',
      GenderShifting: 'Changement de genre',
      GroupSex: 'Sexe de groupe',
      GrowUnhealthy: 'Prise de poids malsaine',
      Gunge: 'Boue',
      GutPunch: 'Coups au ventre',
      HandJob: 'Masturbation',
      HandlerTrainer: 'Maître/Dresseur',
      HandsfreeOrgasm: 'Orgasme sans les mains',
      HeatEstrus: 'Chaleur/Œstrus',
      Heels: 'Talons',
      Humiliation: 'Humiliation',
      Hypnosis: 'Hypnose',
      Hypnotization: 'Hypnose',
      Immobility: "Gaining jusqu'à l'immobilité",
      Inflation: 'Inflation',
      Intersex: 'Intersexe',
      InTraining: 'En formation',
      KennelSleep: 'Dormir dans un panier/chenil',
      Kissing: 'Embrasser',
      KnotPlay: 'Jeu de nœuds/attacher',
      Latex: 'Latex',
      LeashWalk: 'Promener en laisse',
      Leather: 'Cuir',
      Licking: 'Lécher',
      Lipstick: 'Ongles et rouge à lèvres',
      Lycantropy: 'Lycanthropie',
      Lycra: 'Lycra',
      MacroMicro: 'Fantasmes macro/micro',
      Male: 'Homme',
      MalePreg: 'Mpreg (grossesse masculine)',
      ManScent: 'Odeur masculine/corporelle',
      Married: 'Marié',
      Masculine: 'Masculin',
      Masochism: 'Masochisme',
      Mature: 'Partenaires matures/âgés',
      Measuring: 'Mesurer/peser',
      Men: 'Hommes',
      MessyEat: 'Manger salement',
      MessyEating: 'Manger salement/jeu de cochon',
      MicroPenis: 'Micropénis',
      Military: 'Militaire',
      Monogamous: 'Monogame',
      MpregBirthing: 'Mpreg/accouchement',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Croissance musculaire',
      MuscleWorship: 'Adoration musculaire',
      Musk: 'Musc',
      MutualMasturb: 'Masturbation mutuelle',
      Muzzles: 'Muselières',
      Neoprene: 'Néoprène',
      NipplePlay: 'Jeu de tétons',
      NonBinary: 'Non-binaire',
      NonSexPupPlay: 'Jeu de pup non sexuel',
      Obedience: 'Obéissance',
      OlderMen: 'Hommes matures/âgés',
      OpenPolyRelation: 'Dans une relation poly ouverte',
      OpenRelationship: 'Dans une relation ouverte',
      OralBottom: 'Oral (passif)',
      OralPlayBottom: 'Oral (donneur)',
      OralPlayTop: 'Oral (receveur)',
      OralTop: 'Oral (actif)',
      Other: 'Autre',
      Oviposition: 'Ponte',
      Owner: 'Propriétaire',
      Pack: 'Dans une meute',
      Padding: 'Rembourrage',
      Pegging: 'Pegging',
      Petting: 'Gratter/caresser',
      PigPlay: 'Jeu de cochon',
      PissPlay: "Jeux d'urine/sports aquatiques",
      Plugtail: 'Queue avec plug',
      Plush: 'Peluche',
      Polyamorous: 'Polyamoureux',
      PolyRelation: 'Dans une relation poly',
      Pregnancy: 'Grossesse',
      Primal: 'Primitif',
      PublicSex: 'Sexe public/voyeurisme',
      Punks: 'Punks',
      PupGear: 'Équipement de pup',
      PupPlay: 'Jeu de pup',
      PuppyGames: 'Jeux de pup (rapporter, piscine à balles)',
      PuppyToys: 'Jouets de pup',
      Queer: 'Queer',
      Relationship: 'Dans une relation',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (donneur)',
      RimmingReceiver: 'Rimming (receveur)',
      RolePlay: 'Jeu de rôle',
      Rubber: 'Caoutchouc',
      RubberLatexLeather: 'Caoutchouc/latex/cuir',
      Sadism: 'Sadisme',
      SadoMaso: 'Sadomasochisme',
      Saline: 'Salin',
      Scat: 'Scat',
      SciFiGain: 'Gaining de science-fiction',
      Scratching: 'Gratter',
      SensoryDep: 'Privation sensorielle',
      SexualCanineRole: 'Rôle canin sexuel',
      SheathPlay: 'Jeu de prépuce',
      Single: 'Célibataire',
      Skinheads: 'Skinheads',
      Smashing: 'Écraser/broyer',
      SmashingSitting: "Écraser/s'asseoir sur quelqu'un",
      Sniffing: 'Renifler',
      Sounding: 'Sounding/cathéters',
      Spanking: 'Fessée',
      SpeciesSpecific: "Spécifique à l'espèce",
      Speedos: 'Speedos/lycra',
      Sportswear: 'Vêtements de sport',
      Squashing: 'Écrasement',
      StraightMen: 'Hommes hétéros/mariés',
      Stray: 'Errant',
      StretchMarks: 'Vergetures',
      Stuffing: 'Bourrage',
      Submission: 'Soumission',
      Suits: 'Costumes',
      Swinging: 'Échangisme et sexe de groupe',
      TailPulling: 'Tirer la queue',
      Tattoos: 'Tatouages/piercings',
      Teasing: 'Taquiner',
      TeasingPublic: 'Taquiner/humiliation publique',
      Technophilia: 'Technophilie',
      Tentacles: 'Tentacules',
      Tickling: 'Chatouilles',
      TightClothes: 'Vêtements serrés/boutons qui sautent',
      Toons: 'Toons',
      Toys: 'Jouets/godes',
      Trans: 'Transsexuels/intersexuels',
      Transformation: 'Transformation',
      Transgender: 'Transgenre',
      TransMan: 'Homme trans',
      TransMen: 'Hommes trans',
      TransWoman: 'Femme trans',
      TransWomen: 'Femmes trans',
      Treats: 'Friandises/récompenses',
      TwoSpirit: 'Deux esprits',
      Uncle: 'Fantasmes oncle/père/cousin',
      UncollaredUnowned: 'Sans collier/sans propriétaire',
      UnderConsideration: "À l'étude",
      Underwear: 'Sous-vêtements',
      Uniforms: 'Uniformes',
      VacantKennel: 'Chenil vacant',
      VacBed: 'Lit sous vide/sacs sous vide',
      Vanilla: 'Vanille/câlins',
      VetRoleplay: 'Jeu de rôle vétérinaire-animal',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurisme et exhibitionnisme',
      Voyeurism: 'Voyeurisme',
      WaterSports: 'Sports aquatiques',
      WaxPlay: 'Jeu de cire',
      WeightGain: 'Prise de poids',
      Wet: 'Look mouillé/jeans mouillés',
      Widowed: 'Veuf',
      Women: 'Femmes',
      Wrestling: 'Lutte/maillots',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alpha',
      Amphibian: 'Amphibien',
      Aquatic: 'Aquatique',
      Avian: 'Aviaire',
      BBW: 'Big Beautiful Woman',
      Bear: 'Ours',
      BearSpecie: 'Ours',
      Beta: 'Bêta',
      BHM: 'Big Handsome Man',
      Bloater: 'Bloater',
      Bovid: 'Bovidé',
      Boy: 'Garçon',
      Bull: 'Taureau',
      Canid: 'Canidé',
      Cervid: 'Cervidé',
      CatKitten: 'Chat/Chaton',
      Chaser: 'Chaser',
      Chub: 'Chub',
      Chub4Chub: 'Chub4Chub',
      ChubbyBear: 'Chubby Bear',
      Cub: 'Cub',
      Daddy: 'Daddy',
      Dog: 'Chien',
      Dominant: 'Dom',
      Dragon: 'Dragon',
      Encourager: 'Encourager',
      Exotic: 'Exotique',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Félin (grand)',
      FelineSmall: 'Félin (petit)',
      Fox: 'Renard',
      FriendOfPups: 'Ami des pup',
      Gainer: 'Gainer',
      HandlerTrainer: 'Maître/Dresseur',
      Horse: 'Cheval',
      HorsePony: 'Cheval/Poney',
      Hybrid: 'Hybride',
      Maintainer: 'Maintainer',
      Marsupial: 'Marsupial',
      Master: 'Maître',
      Mistress: 'Maîtresse',
      Mommy: 'Maman',
      MuscleGainer: 'Muscle Gainer',
      Omega: 'Oméga',
      Otter: 'Otter',
      OtherMammal: 'Autre (mammifère)',
      OtherSpecie: 'Autre',
      Panda: 'Panda',
      PetOther: 'Animal (Autre)',
      Primate: 'Primate',
      Pup: 'Pup',
      Rabbit: 'Lapin',
      Raccoon: 'Raton laveur',
      Reptilian: 'Reptile',
      Rodent: 'Rongeur',
      Sir: 'Monsieur',
      Skunk: 'Mouffette',
      Slave: 'Esclave',
      Submissive: 'Soumis',
      Switch: 'Switch',
      Wolf: 'Loup',
    },
    Languages: {
      Arabic: 'Arabe',
      Bulgarian: 'Bulgare',
      Chinese: 'Chinois',
      Czech: 'Tchèque',
      Danish: 'Danois',
      Dutch: 'Néerlandais',
      English: 'Anglais',
      Filipino: 'Filipino',
      Finnish: 'Finnois',
      French: 'Français',
      German: 'Allemand',
      Greek: 'Grec',
      Hebrew: 'Hébreu',
      Hindi: 'Hindi',
      Hungarian: 'Hongrois',
      Indonesian: 'Indonésien',
      Italian: 'Italien',
      Japanese: 'Japonais',
      Korean: 'Coréen',
      Norwegian: 'Norvégien',
      Others: 'Autre(s)',
      Persian: 'Persan',
      Polish: 'Polonais',
      Portuguese: 'Portugais',
      Romanian: 'Roumain',
      Russian: 'Russe',
      SerboCroatian: 'Serbo-croate',
      Sign: 'Langue des signes',
      Slovak: 'Slovaque',
      Spanish: 'Espagnol',
      Swedish: 'Suédois',
      Thai: 'Thaï',
      Turkish: 'Turc',
      Ukranian: 'Ukrainien',
      Urdu: 'Ourdou',
      Vietnamese: 'Vietnamien',
    },
    Interests: {
      AddPackMembers: 'Agrandir ma meute',
      Alpha: 'Alpha',
      AsexualRelationship: 'Relation asexuelle',
      BdsmDynamic: 'Dynamique BDSM',
      Beta: 'Bêta',
      Boy: 'Garçon',
      Collaring: 'Collier',
      Daddy: 'Papa',
      Date: 'Rendez-vous',
      Dominant: 'Dom',
      Exploration: 'Initiation/Exploration',
      FormPack: 'Former une nouvelle meute',
      Friends: 'Amis',
      Gaming: 'Jeux',
      HandlerTrainer: 'Maître/Dresseur',
      Hookup: 'Rencontre occasionnelle',
      JoinPack: 'Rejoindre une meute existante',
      Master: 'Maître',
      Mistress: 'Maîtresse',
      Mommy: 'Maman',
      Moshes: 'Moshes/événements de pups',
      NonSexualPlaymates: 'Partenaires de jeu non sexuels',
      Omega: 'Oméga',
      OnlineChat: 'Chat en ligne',
      OnlineVideo: 'Vidéo en ligne (cam2cam)',
      PolyRelation: 'Relation poly',
      PolyRelationship: 'Relation poly',
      Relationship: 'Relation',
      RoleplayPartner: 'Partenaire de jeu de rôle',
      RomanticPartner: 'Partenaire romantique',
      Sex: 'Rencontre occasionnelle',
      SexPartner: 'Partenaire intime régulier',
      Sir: 'Monsieur',
      Slave: 'Esclave',
      Submissive: 'Soumis',
      Switch: 'Switch',
      Training: 'Entraînement',
      VideoChat: 'Chat vidéo',
    },
    Ethnicities: {
      Arab: 'Moyen-Orient/Afrique du Nord',
      Asian: "Asiatique de l'Est",
      Black: 'Noir/descendance africaine',
      Hispanic: 'Hispanique/Latinx',
      Mixed: 'Mixte/multi',
      Native: 'Amérindien/indigène',
      Pacific: 'Îles du Pacifique',
      SouthAsian: 'Asiatique du Sud',
      White: 'Blanc/caucasien',
    },
  },
};
